// src/config/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBcC4iFHXp36lqqOu3JmQU48-xnjAxKwrY",
  authDomain: "dsas-cff9d.firebaseapp.com",
  databaseURL: "https://dsas-cff9d-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dsas-cff9d",
  storageBucket: "dsas-cff9d.firebasestorage.app",
  messagingSenderId: "766029806646",
  appId: "1:766029806646:web:ddf2c2cdfc0c28b40dec97",
  measurementId: "G-SWWEPWBJXC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;  // Export the initialized app